export default class StickyATC extends HTMLElement {
  constructor() {
    super();

    this.observer = null;
    this.isOpen = false;
    this.variantLabel = null;
    this.priceLabel = null;
    this.hasScrolled = false;
    this.scrollThreshold = 50;
    this.lastScrollY = window.scrollY; 
  }

  connectedCallback() {
    this.initializeObserver();
    this.setupListeners();

    this.variantLabel = this.querySelector('[data-variant-label]');
    this.priceLabel = this.querySelector('[data-price-label]');

    window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }

    this.removeEventListener('variant:changed', this.handleVariantChange);
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const currentScrollY = window.scrollY;

    if (currentScrollY > this.scrollThreshold) {
      this.hasScrolled = true;
    }

    if (currentScrollY < this.lastScrollY) {
      this.close(); 
    }

    this.lastScrollY = currentScrollY;
  }

  initializeObserver() {
    const submitButton = document.querySelector(
      '[action="/cart/add"] button[type="submit"]',
    );
    if (!submitButton) {
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Show Sticky ATC only if user scrolled past ATC button
          if (!entry.isIntersecting && this.hasScrolled && this.lastScrollY > 100) {
            this.open();
          } else {
            this.close();
          }
        });
      },
      { threshold: 0 },
    );

    this.observer.observe(submitButton);
  }

  setupListeners() {
    document
      .querySelector('[data-section="product"]')
      .addEventListener('variant:changed', this.handleVariantChange.bind(this));
  }

  handleVariantChange(event) {
    const { variant } = event.detail;

    if (this.variantLabel) {
      this.variantLabel.textContent =
        variant.title && !variant.title.toLowerCase().includes('default')
          ? ` | ${variant.title}`
          : '';
    }

    if (this.priceLabel) {
      this.priceLabel.textContent = variant.price
        ? `$${parseFloat(variant.price / 100).toFixed(2)}`
        : 'Price unavailable';
    }

    this.querySelector('[data-vid]').setAttribute('data-vid', variant.id);
  }

  open() {
    if (!this.isOpen) {
      this.isOpen = true;
      this.setAttribute('data-open', 'true');
    }
  }

  close() {
    if (this.isOpen) {
      this.isOpen = false;
      this.setAttribute('data-open', 'false');
    }
  }
}

export const webcomponent = 'sticky-atc';
